export const RWA_SHARED_ERC20_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "decimals",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "subtractedValue",
        "type": "uint256"
      }
    ],
    "name": "decreaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "addedValue",
        "type": "uint256"
      }
    ],
    "name": "increaseAllowance",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transfer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_SHARED_ERC20_BYTECODE = "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";

export const RWA_SHARED_ERC20_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\r\npragma solidity ^1.1.2;\r\n\r\nimport \"openzeppelin-contracts/token/CRC20/CRC20.sol\";\r\nimport \"openzeppelin-contracts/utils/Checksum.sol\";\r\n\r\n/**\r\n * @title RwaSharedErc20\r\n * @notice Catalog CBC20 (Core CRC20) with owner + optional `minters` for `mint` / `burn`, aligned with\r\n *         commodity-units: OpenZeppelin Core `CRC20`, `Context` / `_msgSender()`, and `Checksum` zero-address rules.\r\n */\r\ncontract RwaSharedErc20 is CRC20 {\r\n    address public owner;\r\n    mapping(address => bool) public minters;\r\n\r\n    event MinterUpdated(address indexed account, bool allowed);\r\n\r\n    function _isZeroLike(address account) private view returns (bool) {\r\n        return account == address(0) || account == Checksum.zeroAddress();\r\n    }\r\n\r\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) CRC20(name_, symbol_) {\r\n        owner = _msgSender();\r\n        for (uint256 i = 0; i < initialMinters.length; i++) {\r\n            address a = initialMinters[i];\r\n            if (!_isZeroLike(a)) {\r\n                minters[a] = true;\r\n                emit MinterUpdated(a, true);\r\n            }\r\n        }\r\n    }\r\n\r\n    function setMinter(address account, bool allowed) external {\r\n        require(_msgSender() == owner, \"Only owner\");\r\n        require(!_isZeroLike(account), \"Zero minter\");\r\n        minters[account] = allowed;\r\n        emit MinterUpdated(account, allowed);\r\n    }\r\n\r\n    function mint(address to, uint256 amount) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender], \"Not minter\");\r\n        require(!_isZeroLike(to), \"Zero to\");\r\n        _mint(to, amount);\r\n    }\r\n\r\n    function burn(uint256 amount) external {\r\n        address sender = _msgSender();\r\n        require(sender == owner || minters[sender], \"Not minter\");\r\n        _burn(sender, amount);\r\n    }\r\n}\r\n";

export const RWA_SHARED_ERC20 = {
  contractName: "RwaSharedErc20",
  abi: RWA_SHARED_ERC20_ABI,
  abiJson: JSON.stringify({ abi: RWA_SHARED_ERC20_ABI, methodIdentifiers: {"allowance(address,address)":"0bf3a456","approve(address,uint256)":"a613914d","balanceOf(address)":"1d7976f3","burn(uint256)":"1d5a4eb6","decimals()":"5d1fb5f9","decreaseAllowance(address,uint256)":"d130efd9","increaseAllowance(address,uint256)":"97ed4190","mint(address,uint256)":"9cff1ade","minters(address)":"d6599743","name()":"07ba2a17","owner()":"be0e67a3","setMinter(address,bool)":"59b62736","symbol()":"231782d8","totalSupply()":"1f1881f8","transfer(address,uint256)":"4b40e901","transferFrom(address,address,uint256)":"31f2e679"} }),
  bytecode: RWA_SHARED_ERC20_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_ERC20_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedErc20.sol"
};
